import useMetaStore from '@/store/useMetaStore';
import useValuesStore from '@/store/useValuesStore';
import { useEffect } from 'react';
import { RuleTigger } from '@/const';
import { PageRule } from '@/store/type';
import rulesCalc from '@/store/rulesCalc';
import _ from 'lodash';
/**
 * 基于字段变更的规则注册
 */
export const useRuleOfChange = () => {
  const { taskInfo, pageConfig, utils, pageType, myRoles, dispatchEvent, destroyEvent } = useMetaStore();
  const { values, setValuesImmediate, pageRules } = useValuesStore();
  const rules = pageRules.filter((x: PageRule) => x.trigger === RuleTigger.FieldChange);
  useEffect(() => {
    // 注册基于事件变更的规则

    const events = rules.filter(x => x.triggerConfig).map(rule => ({
      code: `${rule.triggerConfig?.module}.${rule.triggerConfig?.attribute}.*`,
      moduleName: rule.triggerConfig?.module,
      fieldName: rule.triggerConfig?.attribute,
      rowIndex: '*',
      actionType: 'callback',
      touchConfig: 'change',
      fun: (v: any, { rowIndex }: { rowIndex?: number }) => {
        const calcValues = _.cloneDeep(values || {});
        // 将本次事件变更的值存到之前数据中后进行计算
        if (_.isNumber(rowIndex)) {
          _.set(calcValues, [rule.triggerConfig!.module, rowIndex, rule.triggerConfig!.attribute], v);
        } else {
          _.set(calcValues, [rule.triggerConfig!.module, rule.triggerConfig!.attribute], v);
        }

        const res = rulesCalc(calcValues, [rule], myRoles,taskInfo?.relationTree, rowIndex);
        setTimeout(() => {
          // 只设置本次变更的数据，保证其他数据为最新数据
          setValuesImmediate((prevValues) => {
            rule.entitys?.forEach((entity) => {
              entity.attrs?.forEach((attr) => {
                const key = _.isNumber(rowIndex) ? [entity.code, rowIndex, attr.code] as any : [entity.code, attr.code];
                _.set(prevValues, key, _.get(res.values, key));
              });
            });
            return prevValues;
          });
        }, 1000);
      },
    }));

    const regIds = dispatchEvent(events);
    return () => {
      destroyEvent(regIds);
    };
  }, [values, rules]);
};
